export const GET_GOAL_REVENUES = 'GET_GOAL_REVENUES';
export const GET_GOAL_REVENUE_BY_ID = 'GET_GOAL_REVENUE_BY_ID';
export const UPDATE_GOAL_REVENUE = 'UPDATE_GOAL_REVENUE';
export const DELETE_GOAL_REVENUE = 'DELETE_GOAL_REVENUE';
export const CREATE_GOAL_REVENUE = 'CREATE_GOAL_REVENUE';
export const GET_SALES_STATUS = 'GET_SALES_STATUS';
